// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1MSgu","checkboxCol":"Table_checkboxCol__FCzEr","emailCol":"Table_emailCol__19Qnk","actionCol":"Table_actionCol__2mqnr"};